import React from "react";
import "../App.css";
import CajaSimple from "./CajaSimple";

function Pie() {
    return (
        <div className={"pie"}>
            <div className="wrapper">
                <div className={"linea-estetica"}></div>
                <p className="destacado-rosa">JT Bike Expediciones</p>
                <ul>
                    <li className="facebook"><a href="#"><i className="fa fa-facebook fa-2x"
                                                            aria-hidden="true"></i></a></li>
                    <li className="instagram"><a href="#"><i className="fa fa-instagram fa-2x"
                                                             aria-hidden="true"></i></a></li>
                    <li className="whatsapp"><a href="#"><i className="fa fa-whatsapp fa-2x"
                                                            aria-hidden="true"></i></a></li>
                </ul>
                <p style={{
                    fontSize: "12px",
                    margin: "0",
                    padding: "0",
                    display: "flex",
                    justifyContent: "flex-end",
                    flexDirection: "column",
                    alignContent: "flex-end",
                    alignItems: "flex-end"
                }}>© 2024 Todos los derechos reservados</p>
            </div>

                <CajaSimple
                    encabezado={"Navegación"}
                    descripcion={<ul>
                        <a href="/Inicio">Inicio</a>
                        <a href="/Alquileres">Expediciones</a>
                        <a href="/Contacto">Contacto</a>
                        <a href="/Contacto">Julieta</a>
                    </ul>}
                />


            <CajaSimple
                    encabezado={"Categorías"}
                    descripcion={
                    <ul>
                    <a href="#">Politicas de privacidad</a>
                    <a href="#">Terminos y condiciones</a>
                    <a href="#">Ayuda</a>
                        </ul>}
                />




</div>

)
    ;
}

export default Pie;

